import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonPropertyDetailPageService } from '../common-property-detail-page.service';

@Component({
  selector: 'app-villa-price-analysis-chart',
  templateUrl: './villa-price-analysis-chart.component.html',
  styleUrls: ['./villa-price-analysis-chart.component.scss']
})
export class VillaPriceAnalysisChartComponent {
  @Input() chartId: string = '';
  @Input() Property_Uid: string = '';
  @Input() title: string = '';
  @Input() type: string = '';
  villaPriceAnalysisLoading: boolean = false;
  villaPriceGraphData: any = null;
  @Output() isEmpatyCheck = new EventEmitter();

  constructor(private commonPropService: CommonPropertyDetailPageService) { }


    ngOnInit(): void {
       this.fetchData();
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['property_uid']) {
        this.fetchData();
      }
    }

    fetchData(){
      this.villaPriceAnalysisLoading=true;
      this.commonPropService.getVillaPriceAnalysis(this.Property_Uid, this.type).subscribe({
        next: (res:any)=>{
          this.villaPriceAnalysisLoading=false;
          if(res.status == 200){
            this.villaPriceGraphData = res.data;
          }else{
            this.villaPriceGraphData=null;
            this.updateSection();
          }
        },
        error:(err)=>{
          this.updateSection();
          this.villaPriceAnalysisLoading=false;
          this.villaPriceGraphData = null;
        }
      })
    }

  updateSection() {
    this.isEmpatyCheck.emit(true);
  }
}
